//Import Facebook API Wrappers
import  { replyDirectMessage } from "./replyDirectMessage"
import  { replyDirectMessageAsync } from "./replyDirectMessageAsync"
import  { replyDirectMessageWithAttachment } from "./replyDirectMessageWithAttachment"
import  { replyComment }  from "./replyComment"
import  { replyCommentPrivately }  from "./replyCommentPrivately"
import  { hideComment }  from "./hideComment"
import  { unHideComment }  from "./unHideComment"
import  { deleteComment }  from "./deleteComment"
import  { like }  from "./like"
import  { undoLike }  from "./undoLike"

//Export to use in Components
// api [type] [verb]
// EX: api.directMessage.reply
export default {
  api: {
    comment: {
      reply: replyComment,
      replyPrivately:  replyCommentPrivately,
      hide: hideComment,
      unhide: unHideComment,
      delete: deleteComment,
      like: like,
      undoLike: undoLike
    },
    directMessage: {
      reply: replyDirectMessage,
      replyAsync: replyDirectMessageAsync,
      replyWithAttachment: replyDirectMessageWithAttachment
    }
  }
}


// WEBPACK FOOTER //
// ./src/libs/facebook/index.js